import { MenuItem, styled } from "@mui/material";
import { NavLink } from "react-router-dom";
import { getAccessibleTextColor } from "../BrandingProvider/mealTrackThemeConfigurations";
export const NavDrawerMenuItem = styled(MenuItem, {
    shouldForwardProp: (prop) => !["isNavDrawerMenuTrigger"].includes(prop), // Cast `prop` to string
})(({ theme, isNavDrawerMenuTrigger }) => {
    var _a, _b, _c, _d;
    const headerTextColor = ((_a = theme.palette.header) === null || _a === void 0 ? void 0 : _a.textColor) || theme.palette.common.black;
    const headerBgColor = ((_b = theme.palette.header) === null || _b === void 0 ? void 0 : _b.backgroundColor) || theme.palette.common.white;
    return {
        padding: `${theme.spacing(1.5)} ${theme.spacing(3.75)}`,
        ".MuiTypography-root": {
            color: getAccessibleTextColor(theme, headerTextColor, headerBgColor),
            fontFamily: ((_d = (_c = theme.typography.header) === null || _c === void 0 ? void 0 : _c.navText) === null || _d === void 0 ? void 0 : _d.fontFamily) || theme.typography.fontFamily,
        },
        "&.Mui-selected": {
            padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
            borderLeft: !isNavDrawerMenuTrigger && `${theme.spacing(0.75)} solid ${theme.palette.primary.main}`,
        },
        "&.is-nav-drawer-logout": {
            display: "flex",
            marginTop: "auto",
            position: "absolute",
            bottom: 0,
            width: "100%",
            backgroundColor: theme.palette.primary.main,
            color: getAccessibleTextColor(theme, headerTextColor, theme.palette.primary.main),
            ".MuiTypography-root": {
                color: getAccessibleTextColor(theme, headerTextColor, theme.palette.primary.main),
            },
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        "&.is-nav-menu-logout": {
            marginTop: theme.spacing(0.5),
            display: "flex",
            width: "100%",
            color: getAccessibleTextColor(theme, headerTextColor, headerBgColor),
        },
    };
});
/**
 * Sets the default props. DO NOT CHANGE.
 * If additional customizations are required, creating a new styled component is likely the better approach.
 */
NavDrawerMenuItem.defaultProps = {
    component: NavLink, // The typography component will use the React-Router Nav Link component as it's base.
};
